// plugins/device-detect.js 用于检测设备类型、窗口宽度和底部导航栏
import { isMobile } from "@/utils/device";

export default {
  install(Vue) {
    // 底部导航栏高度缓存
    let bottomNavHeight = 0;

    // 初始化时计算一次底部导航高度
    // calculateBottomNavHeight();

    // 添加全局设备检测属性
    Vue.prototype.$device = {
      // 设备类型检测
      isMobile: isMobile(),
      get isPc() {
        return !this.isMobile;
      },

      // 浏览器类型检测
      isSafari() {
        const userAgent = navigator.userAgent.toLowerCase();
        return (
          userAgent.includes("safari") &&
          !userAgent.includes("chrome") &&
          !userAgent.includes("edge")
        );
      },
      isIOS() {
        return /iphone|ipad|ipod/i.test(navigator.userAgent);
      },

      // 窗口宽度检测
      checkByWidth() {
        return window.innerWidth < 768;
      },

      // 底部导航栏相关方法
      getBottomNavHeight() {
        return bottomNavHeight;
      },

      /**
       * 处理容器的底部导航栏适配
       * @param {string} containerId - 容器ID
       */
      handleBottomNavCompatibility(containerId) {
        const container = document.getElementById(containerId);
        if (!container) {
          console.warn(`[DeviceDetect] 未找到ID为"${containerId}"的容器`);
          return;
        }

        // 设置底部内边距以适配导航栏
        container.style.paddingBottom = `${bottomNavHeight}px`;

        // 返回一个清理函数，方便在组件销毁时使用
        return () => {
          container.style.paddingBottom = "";
        };
      },
    };

    // 计算底部导航栏高度
    function calculateBottomNavHeight() {
      // 优先使用安全区域变量（现代浏览器）
      if (
        window.CSS &&
        CSS.supports("padding-bottom", "env(safe-area-inset-bottom)")
      ) {
        //获取值后先去除单位再转换为数字
        const heightValue = getComputedStyle(document.documentElement)
          .getPropertyValue("env(safe-area-inset-bottom)")
          .replace(/\D/g, ""); // 移除所有非数字字符
        bottomNavHeight = parseInt(heightValue, 10) || 0;
      }
      // Safari/iOS 降级处理
      else if (
        Vue.prototype.$device.isSafari() &&
        Vue.prototype.$device.isIOS()
      ) {
        bottomNavHeight = 34; // iOS 全面屏设备经验值
      }
      // 其他移动设备默认值
      else if (Vue.prototype.$device.isMobile) {
        bottomNavHeight = 20; // 普通移动设备默认值
      }
      // 桌面设备
      else {
        bottomNavHeight = 0;
      }
      console.log(`底部导航栏高度: ${bottomNavHeight}px`);
    }

    // // 监听窗口变化，重新计算底部导航高度
    // window.addEventListener("resize", () => {
    //   calculateBottomNavHeight();
    // });

    // // 监听屏幕旋转
    // window.addEventListener("orientationchange", () => {
    //   calculateBottomNavHeight();
    // });
  },
};
